import { picDataFormat, filterParams } from '@/common/utils/format'
import { get, pick } from 'lodash-es'
import { i18n, getBDCountry, sprintf } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'


const KEYS = ['pics', 'files']

export function revert (data = {}) {
  const other = get(data, 'bizGlobal.extraInfo.bankFlow')
  let revertted = {}
  if (other) {
    revertted = pick(other, KEYS)
    revertted.pics = picDataFormat(other.pics, other.pics)
  }
  return revertted
}

const formatImg = item => {
  console.log(item)
  return item.customUrl
}

const makeImageObj = obj => {
  return Object.keys(obj).reduce((target, key) => {
    target[key] = Array.isArray(obj[key])
      ? obj[key].map(formatImg) : null
    return target
  }, {})
}

export function submitFormat (bankFlow) {
    const email = makeImageObj(get(this, 'signForm.emailInfo') || {})
    const other = makeImageObj(get(this, 'signForm.othersInfo') || {})
    const json = {
      source: 'contractor',
      queryId: this.id,
      bizGlobal: {
        extraInfo: {
          email,
          bankFlow,
          other
        }
      }
    }
    return {
      params: JSON.stringify(json)
    }
  }

export default {
  revert,
  submitFormat
}
